function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUsersAssigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M238.652,179.765c-7.588-59.987-55.579-106.226-113.652-106.226S18.935,119.778,11.348,179.765h227.305Z",
    style: {
      fill: "#f2f8fd"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.844,87.164c.392.925.877,1.407,1.135,3.15.035.238.113.298.397.241,2.445-.494,9.992.32,10.207-2.24.073-.866-.467-4.537-.866-5.307-.643-1.238-4.293-2.915-5.659-3.083-3.492-.43-6.751,3.609-5.214,7.238Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.444,89.725c.38.315-2.114,3.372-4.349,3.372s-4.412-2.765-4.16-3.202c.082-.143,2.195-1.171,4.43-1.171s3.843.804,4.079,1Z",
    style: {
      fill: "#151f22"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.407,92.81c-3.413-2.341-6.505-2.163-5.468-8.63l-5.736-.142c-.065,4.772.249,5.098-1.621,6.934-.412.404-3.068,2.115-3.068,2.115,4.444,3.78,12.296,3.143,15.894-.277Z",
    style: {
      fill: "#e79a89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.204,78.34c.934,9.446,9.535,12.713,10.538,4.698,1.81-14.465-11.298-12.386-10.538-4.698Z",
    style: {
      fill: "#e79a89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.006,78.602c-.907-.053-.543,1.842-.337,2.777.405,1.842,1.766-2.694.337-2.777Z",
    style: {
      fill: "#e79a89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.883,83.346c-1.57-2.07.096-4.051,1.032.118.245,1.093-.796.194-1.032-.118Z",
    style: {
      fill: "#e79a89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.387,81.381c-.294.073-.786-1.053-.074-1.231.38-.095.554,1.111.074,1.231Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.423,80.126c.294-.073.261-1.314-.452-1.136-.38.095-.029,1.256.452,1.136Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.726,82.822c1.107.183.926-.307.63-.21-.982.321-.084-.387-.444-2.147-.038-.185-.24-.136-.227.02.009.108.084.496.086.612.021,1.437-.398,1.667-.045,1.725Z",
    style: {
      fill: "#d57859"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.187,83.971c-1.29,3.073-3.347.764-2.892.643,2.62-.702,3.026-.96,2.892-.643Z",
    style: {
      fill: "#d57859"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.83,82.013c.006-.092.137-.082.131.009-.035.555.181.821.408.888.373.109-.619.38-.539-.897Z",
    style: {
      fill: "#d57859"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.11,80.586c.133-.272.022-.618-.094-.92-.033-.085.089-.137.122-.052.433,1.135-.148,1.217-.028.972Z",
    style: {
      fill: "#d57859"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.496,86.923c-.098-.064-.006-.22.091-.156,1.878,1.233,3.935.954,5.003-.678.065-.1.208.005.143.105-1.123,1.717-3.276,2.017-5.237.73Z",
    style: {
      fill: "#d57859"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.359,78.875c.463-.051.502.341.18.495-3.436,1.641-1.326-.37-.18-.495Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.094,77.821c-.431.186-.292.551.06.526,3.761-.26,1.007-.986-.06-.526Z",
    style: {
      fill: "#5c3022"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.75,92.912c-.007,5.007.793,14.14,2.185,18.885.838,2.858,12.636,2.21,12.999-.275.715-4.9,2.222-13.529,2.212-18.742l-4.883-2.468c-1.38,2.834-7.101,2.718-8.326.296l-4.187,2.304Z",
    style: {
      fill: "#fffffa"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.915,92.313c-.115-.107.039-.291.153-.184,3.348,3.115,3.971,3.59,4.551,2.79,2.128-2.934,2.703-4.156,2.709-4.168.097-.208,1.061-.626-2.525,4.318-.751,1.035-1.64.291-4.887-2.756Z",
    style: {
      fill: "#e7aa47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.081,95.843c-.487,0-.488-.781,0-.781s.488.781,0,.781Z",
    style: {
      fill: "#c75127"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.167,94.56c-.252,0-.253-.405,0-.405s.253.405,0,.405Z",
    style: {
      fill: "#c75127"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.775,94.965c-.379,0-.379-.607,0-.607s.379.607,0,.607Z",
    style: {
      fill: "#c75127"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.154,173.423c.604,1.901,2.796,1.905,3.124-.258l.014-5.238-3.9-.06.762,5.557Z",
    style: {
      fill: "#e79a89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.613,172.557c-2.014.718-4.763.572-4.858-.171-6.931-54.376-9.95-53.71-1.305-59.25l6.249.416c1.375,9.018.292,58.871-.087,59.006Z",
    style: {
      fill: "#ecb85f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75,92.912c-1.284.507-1.575,1.392-2.221,2.218-2.923,3.736-2.125,5.683-4.26,8.496-1.25,1.648-1.966,3.685-2.186,5.777-.196,1.861,2.518,5.9,3.581,7.379,1.672,2.325,1.665,2.968,2.64,2.968,0,0,.028-2.392,2.001-4.016-1.115-3.574-1.487-4.212-2.354-5.804,5.304-9.29,6.476-10.331,6.718-13.12.229-2.631-1.422-4.882-3.919-3.897Z",
    style: {
      fill: "#151f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.184,178.612c-.115-.194-.135-.442-.057-.655.228-.621,6.259-4.696,6.027-4.534,1.098.735,2.57.369,3.124-.258.378.838,1.468,3.856.368,4.157-.657.18-8.977,2.107-9.463,1.29Z",
    style: {
      fill: "#2b3039"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.491,173.515c.604,1.901,2.796,1.905,3.124-.258l.014-5.238-3.901-.06.762,5.557Z",
    style: {
      fill: "#e79a89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.521,178.704c-.343-.577.162-1.092.691-1.468,2.471-1.757,5.28-3.72,5.28-3.72,1.098.735,2.57.369,3.124-.258.334.738,1.5,3.849.35,4.162-.661.18-8.954,2.111-9.445,1.285Z",
    style: {
      fill: "#2b3039"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.999,172.959c1.673.326,4.477-.383,4.515-1.127,3.03-58.516-3.949-59.237-3.949-59.237l-7.866.956c-.693,10.753,6.27,59.208,7.299,59.408Z",
    style: {
      fill: "#ecb85f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.277,111.813c-6.271-18.975-6.559-19.229-5.224-20.261.463-.358,1.882-1.657,1.882-1.657.648.367,6.424,11.457,3.343,21.918Z",
    style: {
      fill: "#151f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.266,97.049c-.029,0-.059-.011-.082-.033-.048-.045-.05-.12-.005-.168l2.581-2.734-2.939-.248c-.066-.006-.114-.063-.109-.129.006-.065.062-.115.129-.109l3.432.289-2.92,3.093c-.023.025-.055.037-.087.037Z",
    style: {
      fill: "#4b545b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.277,111.932s-.008,0-.013,0c-.065-.007-.113-.065-.106-.131l.029-.27c.229-2.149.765-7.18-.882-8.996l.047-.042-.052.025c-.091-.161-2.576-3.468-5.109-5.494-.051-.041-.06-.116-.019-.167.041-.051.116-.06.167-.019,2.212,1.769,4.76,4.899,5.137,5.543,1.724,1.89,1.18,6.996.948,9.176l-.029.269c-.006.061-.058.107-.118.107Z",
    style: {
      fill: "#4b545b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.831,93.748l3.186.268-2.751,2.914c1.705,1.313,5.395,5.202,5.992,7.188.851,2.826-.122,9.373-1.027,12.277-2.407.299-4.959-.428-7.729-1.064-1.427-11.153-.037-20.908-.009-21.54.02-.457,4.433-3.547,5.442-3.896l-3.104,3.853Z",
    style: {
      fill: "#343c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.414,114.312s6.681-16.622,6.64-17.083c-.07-.775-.503-4.376-1.08-4.822-.463-.358-3.531-2.682-3.531-2.682-.702,1.789-2.469,20.053-2.03,24.587Z",
    style: {
      fill: "#151f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.089,97.102c-.03,0-.061-.012-.084-.035l-3.181-3.173,2.648-1.257c.06-.028.13-.003.159.056.028.059.003.13-.056.159l-2.343,1.112,2.942,2.935c.047.046.047.122,0,.168-.023.023-.054.035-.084.035Z",
    style: {
      fill: "#4b545b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.358,111.871c-.073-.004-.123-.061-.119-.126.475-7.556,2.309-10.083,5.637-14.671l.116-.16c.038-.053.113-.065.166-.026.053.039.065.113.026.166l-.116.16c-3.302,4.552-5.121,7.06-5.592,14.546-.004.063-.056.112-.119.112Z",
    style: {
      fill: "#4b545b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.523,92.863c-.03,0-.06-.011-.083-.034l-2.837-2.782c-.047-.046-.048-.121-.002-.168.046-.047.121-.048.168-.002l2.837,2.782c.047.046.048.121.002.168-.023.024-.054.036-.085.036Z",
    style: {
      fill: "#4b545b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.997,118.982c-.041,0-.081-.021-.103-.059-1.029-1.763-2.472-2.946-4.063-3.329-.064-.015-.103-.08-.088-.144.015-.064.08-.103.144-.088,1.655.399,3.151,1.621,4.213,3.441.033.057.014.13-.043.163-.019.011-.04.016-.06.016Z",
    style: {
      fill: "#bc893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.523,92.744l-2.495,1.185,3.061,3.054c-1.266,1.626-3.935,5.422-4.533,7.408-.851,2.826-1.77,9.344-.864,12.248,3.104-.214,6.699-.747,9.048-1.77,1.427-11.153-1.555-21.873-1.583-22.505-.02-.457-4.704-2.291-5.713-2.64l3.079,3.019Z",
    style: {
      fill: "#343c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.713,115.561c-.056,0-.106-.04-.117-.097l-1.139-5.959c-.243-.195-.331-.391-.26-.583.271-.737,3.052-.899,3.899-.849.066.004.116.06.112.126-.004.066-.06.116-.126.112-1.127-.065-3.483.207-3.662.693-.042.113.095.247.217.339l.037.028,1.156,6.049c.012.065-.03.127-.095.139-.008.001-.015.002-.022.002Z",
    style: {
      fill: "#151f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.96,124.538c-.144,0-.305-.007-.483-.02-.066-.005-.115-.062-.11-.127s.062-.113.128-.11c.742.055,1.144-.005,1.34-.203.163-.164.211-.447.166-.977-.093-1.104-.19-2.64-.283-4.126-.126-2.003-.268-4.265-.36-4.589-.004-.003-.008-.007-.012-.011-.043-.049-.039-.125.011-.168.034-.03.091-.04.133-.022.137.057.18.243.465,4.776.093,1.484.19,3.019.283,4.121.037.444.035.893-.235,1.165-.199.201-.515.293-1.044.293Z",
    style: {
      fill: "#bc893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.173,110.133c-.046,0-.089-.026-.109-.07-.027-.06,0-.13.06-.157,2.018-.904,7.15-2.517,7.202-2.533.063-.02.129.015.149.078.02.063-.015.129-.078.149-.051.016-5.171,1.624-7.175,2.523-.016.007-.032.01-.049.01Z",
    style: {
      fill: "#4b545b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.324,91.77s2.237.478,4.279,4.132c.804,1.438,2.587,3.109,3.891,5.728.705,1.417,1.633,3.439,2.723,4.958,3.177,4.428-5.838,5.405-6.478,5.748-.944.507-4.032,1.515-5.822,1.425-1.646-.083-3.214.267-4.131.267-.586-.826-1.094-2.09-.902-3.175,3.141-1.329,8.018-3.314,11.284-4.148-3.039-2.296-3.397-3.016-3.397-3.016-.742-3.249-1.449-9.877-1.448-11.919Z",
    style: {
      fill: "#151f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.471,112.05c-.051-.131-.005-.302-.078-.442-.09-.171-.257-.305-.42-.421-.399-.285-.841-.472-1.321-.615-.317-.094-.633-.198-.956-.268-.167-.036-.505-.157-.648-.092-.146.067-.224.334-.153.46,1.204,2.14-1.258-.326.881.572.397.166.561.728.988.806.455.084,1.204-.187,1.709,0Z",
    style: {
      fill: "#e79a89"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.365,115.282c-.437.715-2.833,1.089-3.568.115l-1.172-6.156c1.591.893,4.236.403,5.162-.431l-.422,6.473Z",
    style: {
      fill: "#d5d5d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.574,108.29c.22.168-1.31.888-2.41.942-1.065.052-2.704-.363-2.556-.564.35-.472,4.565-.683,4.965-.378Z",
    style: {
      fill: "#c75127"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.176,108.669c-.299-.049,1.301-.34,1.923-.376,4.074-.236.67.801-1.923.376Z",
    style: {
      fill: "#4e5976"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.995,108.714c-.098-.222-.166-.266-.421-.423-1.122.744-3.388.941-4.965.378-1.454,1.174,4.239,1.884,5.386.045Z",
    style: {
      fill: "#4e5976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.454,78.885c-.399,3.73,1.099,3.902,1.215,4.78.17,1.288-1.871,1.173,1.475,5.932.578.822,5.37-.291,5.454-1.094.163-1.56.798-3.296-.222-4.528-.396-.478-1.128-.784-1.415-1.308-.451-.823.316-1.915.052-2.798-.43-1.436-3.343-1.763-3.676-3.225-.169-.743.571-3.283-1.583-5.187-2.785-2.462-8.632-.276-6.155,2.677,0,0,5.43-.611,4.856,4.751Z",
    style: {
      fill: "#6d3d29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.971,81.481c1.857,3.196.57,4.027.817,4.873.172.589,2.765,1.86.852,5.553-.485.936-4.786,2.634-5.184,1.946-.774-1.339-2.045-2.624-1.615-4.199.167-.611.707-1.217.756-1.821.078-.948-1.054-1.591-1.169-2.51-.187-1.494,2.319-3.101,2.034-4.574-.145-.749-1.615-2.618-.647-5.408,1.54-4.44,7.667-5.739,6.917-1.218-.382,1.493-5.984,1.813-2.762,7.358Z",
    style: {
      fill: "#6d3d29"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.618,73.613c.054-.523-.084-1.066-.379-1.49-.087-.125.092-.264.178-.139.327.47.48,1.073.42,1.654-.016.154-.236.128-.22-.025Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.825,71.894c.54-.703,1.436-1.065,2.281-.922.145.025.109.256-.035.231-.769-.13-1.583.199-2.075.838-.092.12-.264-.027-.171-.148Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.125,72.637c-.142-.033-.096-.262.047-.229.284.066.515-.539.947-.313.131.069.033.279-.098.21-.271-.142-.476.429-.897.332Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.753,74.025c-1.144-.733-1.007-.741-2.261-.659-.136.009-.287.046-.295-.098-.008-.143.146-.127.281-.136,1.323-.087,1.2-.069,2.389.692.125.08.011.28-.114.2Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.746,72.162c-.535-.496-1.921-.157-2.148.239-.076.132-.265.011-.189-.122.308-.535,1.855-.876,2.483-.294.11.102-.036.278-.146.176Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.04,73.321c-.13-.071-.028-.279.102-.208.306.168.556-.649,1.105-.295.124.08.01.281-.115.2-.393-.253-.596.575-1.092.303Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.24,75.574c.376-.844,2.124-1.202,1.837-1.904-.145-.355.648-.081.021.661-.487.577-1.365.686-1.658,1.342-.062.14-.262.04-.2-.1Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.654,78.249c-1.035-1.593.736-3.663.814-4.142.025-.153.243-.113.218.04-.09.553-1.793,2.518-.85,3.969.083.128-.099.26-.182.133Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.742,84.95c.558-4.14-2.556-3.488-1.149-7.561.05-.146.258-.065.208.081-1.325,3.833,1.714,3.401,1.16,7.513-.021.153-.24.12-.219-.033Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.256,78.725c-2.499-1.48-1.835-2.786-1.729-3.89.155-1.607-.801-3.056-1.466-3.088-.146-.007-.136-.241.01-.234.843.041,1.838,1.665,1.676,3.346-.108,1.12-.736,2.267,1.617,3.662.128.076.02.28-.108.204Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.039,88.284c-3.027-1.834.295-2.536-1.388-4.75-.524-.689-1.877-1.757-1.527-3.058.04-.149.253-.085.213.064-.311,1.157.952,2.143,1.487,2.847,1.81,2.379-1.528,2.965,1.325,4.693.127.077.017.28-.11.203Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.477,86.424c-.611-3.64-2.367-1.228-2.166-4.567.029-.477.126-1.417-.53-1.812-.135-.081-.232-.084-.257-.073-.236.106-.239-.496.367-.131.766.462.673,1.486.641,2.03-.193,3.216,1.52.679,2.163,4.511.025.152-.192.194-.218.041Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.19,87.965c-.49-1.521-.813-1.237-1.499-2.002-.495-.552-.679-1.378-.468-2.106.043-.148.254-.079.211.069-.185.638-.017,1.392.417,1.876.655.729,1.035.493,1.549,2.087.047.146-.162.223-.209.076Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.868,90.796c-.215-1.582.803-2.506-.462-4.148-1.135-1.473-.618-2.268.744-4.898.07-.136.264-.023.194.113-3.113,6.009.472,3.081-.177,7.468-.077.519-.345,2.033.504,2.383.057.023.085.091.063.152-.089.241-.744-.169-.866-1.07Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.418,89.619c.205-1.038.398-2.019-1.876-2.907-.137-.053-.061-.273.076-.22,2.453.958,2.231,2.085,2.016,3.175-.081.412-.234,1.083.048,1.287.293.211-.665.694-.265-1.335Z",
    style: {
      fill: "#5c3022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.281,92.409c-.208-.854-.255-1.084-.379-1.319-.193-.365-.935-1.003-.616-2.106.043-.149.254-.079.211.069-.283.977.39,1.529.597,1.923.14.265.188.502.4,1.375.037.151-.178.208-.214.059Z",
    style: {
      fill: "#5c3022"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.007,108.222c-.047,0-.087-.037-.089-.085-.202-4.356-.009-6.901.257-10.423.083-1.098.177-2.342.268-3.765.003-.049.043-.087.095-.083.049.003.087.046.083.095-.092,1.424-.186,2.668-.269,3.766-.276,3.647-.458,6.056-.256,10.401.002.049-.036.091-.085.093h-.004Z",
    style: {
      fill: "#272d33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.144,110.38c-.027,0-.054-.012-.072-.036-.029-.04-.021-.096.019-.125l.035-.026c.255-.189.713-.539,1.208-.524-.451-.38-.98-.972-.789-1.549.015-.047.066-.073.113-.057.047.015.072.066.057.113-.217.656.778,1.41,1.088,1.626.062.043.078.089.047.138-.047.073-.12.03-.155.01-.529-.306-1.136.144-1.462.386l-.036.027c-.016.012-.035.017-.053.017Z",
    style: {
      fill: "#272d33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.655,105.975c-.02,0-.04-.006-.056-.02-.577-.468-.507-1.273-.41-2.389.014-.163.029-.333.042-.511.004-.049.048-.085.096-.082.049.004.086.047.082.096-.014.178-.028.349-.043.513-.092,1.06-.159,1.826.345,2.234.038.031.044.087.013.126-.018.022-.043.033-.069.033Z",
    style: {
      fill: "#272d33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.124,102.787c-.038,0-.074-.025-.086-.064-.425-1.411-.479-2.919-.156-4.36.011-.048.059-.078.107-.068.048.011.078.059.068.107-.316,1.411-.263,2.888.153,4.27.014.047-.013.097-.06.111-.009.003-.017.004-.026.004Z",
    style: {
      fill: "#272d33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.532,104.615c-.024,0-.048-.01-.066-.029l-.779-.868c-.433-1.27-1.546-11.472-1.446-11.764.016-.047.067-.071.114-.055.045.016.07.064.057.109-.058.355.976,10.222,1.439,11.635l.747.823c.033.037.03.093-.006.126-.017.016-.039.023-.06.023Z",
    style: {
      fill: "#272d33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.009,108.122c-.041,0-.078-.028-.087-.07-.145-.65-.679-1.188-1.3-1.308l-.073-.014-.009-.084c.002-.194,1.083-.762,2.002-.923.049-.008.095.024.103.073.008.048-.024.095-.073.103-.808.142-1.518.53-1.77.706.625.184,1.146.743,1.294,1.409.011.048-.02.096-.068.107-.007.001-.013.002-.02.002Z",
    style: {
      fill: "#272d33"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.473,120.617c-.009,0-.018-.001-.027-.003-.064-.015-.104-.078-.089-.143.463-2.019.975-3.772,2.556-4.774.056-.035.129-.019.164.037.035.056.019.129-.037.164-1.504.953-2,2.659-2.452,4.626-.013.055-.062.092-.116.092Z",
    style: {
      fill: "#bc893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.475,128.695c-.088,0-.126-.079-.217-.267-.15-.313-.463-.963-.936-1.124-.197-.067-.402-.045-.626.068-.059.03-.13.006-.16-.052-.03-.059-.006-.13.053-.16.28-.141.552-.169.81-.081.531.18.865.814,1.04,1.175.284-1.131.78-1.539,1.16-1.68.419-.155.845-.037,1.082.149.052.041.061.115.02.167-.04.052-.115.061-.167.02-.138-.108-.472-.253-.852-.113-.353.131-.825.546-1.071,1.782l-.017.084-.096.03c-.008.001-.015.002-.022.002Z",
    style: {
      fill: "#bc893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.258,171.962c-.066,0-.119-.054-.119-.12.002-.265.16-26.672.569-42.35.002-.066.055-.114.122-.116.066.002.118.056.116.122-.408,15.675-.567,42.08-.569,42.345,0,.066-.054.118-.119.118Z",
    style: {
      fill: "#bc893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.761,171.657c-.071-.003-.122-.058-.119-.124.015-.35,1.432-35.188-.913-50.585-.01-.065.035-.126.1-.136.067-.009.126.035.136.1,2.348,15.42.93,50.281.916,50.631-.003.064-.055.114-.119.114Z",
    style: {
      fill: "#bc893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.059,113.631l-.09-.418c-.028-.128.07-.256.211-.262.771-.033,1.51,0,1.709-.065-.62.031-1.234-.007-1.778.016-.119.005-.224-.069-.247-.177l-.067-.313c-.029-.132.075-.257.221-.263.752-.031,2.611-.081,3.952-.288,2.047-.316,1.913-.489,2.327-.485.086,0,.4,1.228.434,1.3.085.175.075.47.05.619-.129.782-.94.831-1.139.914-.808.34-.192.642-2.174.858-.863.094-2.041.248-2.842.262-.116.002-.217-.072-.239-.177l-.04-.187c-.026-.119.057-.235.186-.259.514-.096,1.189-.156,1.743-.248-.016,0-.889.115-1.782.184-.121.009-.23-.066-.254-.176l-.08-.37c-.028-.128.07-.25.21-.262.639-.053,1.285-.126,1.616-.149-.36-.038-1.013.078-1.676.124-.12.008-.227-.068-.25-.177Z",
    style: {
      fill: "#e79a89"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146.651,89.644c-.916-.521,6.646-.377,5.787,0-1.994.875-4.719.608-5.787,0Z",
    style: {
      fill: "#da454d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.46,96.172c.657-1.088,1.902-1.914,2.016-3.173.107-1.178-.839-2.185-1.126-3.334-.583-2.341,1.51-3.383,1.928-3.936,1.24-1.642-.758-7.76,3.145-10.334,1.295-.854,3.202-.906,4.326.156.68-.21,1.595-.797,2.599-.498,1.104.328,2.934,2.7,3.185,4.245.288,1.769-.638,3.672.071,5.322.641,1.49,2.85,2.54,2.386,5.817-.056.396-.841,1.929-1.099,2.239-.818.981.608,2.538.927,3.765l-18.359-.27Z",
    style: {
      fill: "#493c35"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M157.208,95.308c-3.115-2.141-6.012-2.093-4.829-7.651l-5.359-.319c-.218,4.125.065,4.418-1.744,5.942-.398.336-2.939,1.725-2.939,1.725,4.031,3.421,11.394,3.138,14.871.303Z",
    style: {
      fill: "#e39889"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.764,80.182c-1.081,8.152,6.08,12.729,8.632,6.192,4.606-11.795-7.752-12.827-8.632-6.192Z",
    style: {
      fill: "#e39889"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.544,82.695c-.815-.237-.871,1.436-.875,2.267-.008,1.637,2.158-1.893.875-2.267Z",
    style: {
      fill: "#e39889"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.411,82.589c.816-.233.863,1.441.863,2.271,0,1.637-2.148-1.904-.863-2.271Z",
    style: {
      fill: "#e39889"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.04,83.418c-.282,0-.501-1.054.185-1.052.366,0,.278,1.053-.185,1.052Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.881,83.431c.282,0,.506-1.051-.179-1.053-.366,0-.283,1.052.179,1.053Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.553,81.024c.454.029.432.384.098.47-.448.115-.542-.046-1.503.279-1.062.358.193-.826,1.406-.749Z",
    style: {
      fill: "#493c35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.09,81.129c-.455.009-.449.366-.118.466.443.134.611-.003,1.49.342,1.043.41-.146-.833-1.371-.808Z",
    style: {
      fill: "#493c35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.875,85.128c.97.389.905-.062.617-.043-.959.062.002-.344.035-1.902.003-.164-.19-.166-.211-.031-.014.093-.025.436-.047.533-.274,1.215-.704,1.319-.394,1.443Z",
    style: {
      fill: "#d1785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.721,86.541c.09-.024.16.076.102.148-1.756,2.195-3.058-.074-2.76-.176.605-.208,1.561.326,2.658.028Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.583,83.407c.024-.076.141-.04.117.036-.145.46-.003.73.19.834.03.016.04.053.024.082-.109.193-.538-.294-.331-.951Z",
    style: {
      fill: "#d1785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.233,84.388c.177-.201.146-.515.103-.794-.012-.079.109-.096.121-.018.162,1.047-.387.996-.224.812Z",
    style: {
      fill: "#d1785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.197,88.3c1.632,1.767,4.141,1.137,4.835.137.274-.39.023.949-2.06,1.09-2.3.156-3.246-1.738-2.775-1.227Z",
    style: {
      fill: "#d1785e"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.902,176.275c.619,1.753,2.81,1.741,3.122-.263l-.025-4.845-3.901-.025.804,5.134Z",
    style: {
      fill: "#e79a89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.518,176.264c.57,1.769,2.761,1.815,3.128-.18l.109-4.844-3.899-.129.661,5.154Z",
    style: {
      fill: "#e79a89"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M137.971,181.121c-.117-.178-.138-.407-.062-.605.224-.577,6.224-4.392,5.993-4.241,1.103.671,2.572.321,3.122-.263.385.772,1.497,3.555.4,3.843-.655.172-8.961,2.019-9.453,1.267Z",
    style: {
      fill: "#eee6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.867,181.407c-.527,0-.888-.065-.992-.223-.137-.209-.164-.474-.073-.709.214-.552,4.834-3.531,5.896-4.189l-.01-.006.151-.099.01.013c.04-.024.063-.037.065-.037,0,0,.083.005.083.005l.012.045c1.062.61,2.437.253,2.931-.272l.113-.12.073.147c.328.659,1.176,2.737.777,3.615-.093.204-.244.335-.451.389-.073.019-6.126,1.442-8.587,1.442ZM143.903,176.408c-.741.46-5.708,3.687-5.887,4.149-.064.164-.044.356.051.501.403.615,7.964-.958,9.328-1.315.139-.036.237-.122.301-.262.313-.69-.314-2.442-.706-3.28-.627.527-1.989.834-3.086.206Z",
    style: {
      fill: "#fffffa"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M141.154,179.711c-.247,0-.532-.081-.745-.183-.185-.088-.419-.239-.48-.46-.034-.122.038-.248.16-.282.122-.033.247.037.282.158.013.03.105.119.309.202.269.11.514.123.588.091.116-.051.251.002.301.118.051.116-.002.251-.118.301-.085.037-.187.053-.296.053Z",
    style: {
      fill: "#fffffa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.38,178.856c-.477,0-.945-.246-1.202-.645-.069-.106-.038-.248.069-.317.106-.069.248-.038.316.068.19.296.572.471.927.429.126-.014.24.074.255.199.015.126-.074.24-.2.255-.055.007-.11.01-.165.01Z",
    style: {
      fill: "#fffffa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.462,178.029c-.429,0-.859-.159-1.178-.442-.095-.084-.103-.229-.019-.323.084-.095.229-.104.323-.019.269.238.646.357,1.006.319.128-.014.239.078.252.204.013.126-.078.239-.204.252-.06.006-.12.01-.18.01Z",
    style: {
      fill: "#fffffa"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148.454,180.951c-.333-.541.182-1.007.718-1.345,2.502-1.579,5.346-3.341,5.346-3.341,1.084.7,2.562.39,3.128-.18.32.689,1.43,3.587.275,3.856-.664.154-8.99,1.784-9.467,1.01Z",
    style: {
      fill: "#eee6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,181.261c-.628,0-1.063-.072-1.173-.25-.302-.49-.048-.996.754-1.502,2.474-1.561,5.318-3.324,5.347-3.342l.062-.038.061.039c1.049.678,2.469.355,2.985-.164l.116-.117.069.149c.309.666,1.097,2.761.675,3.628-.101.207-.262.338-.478.388-.072.016-5.854,1.209-8.417,1.209ZM148.552,180.891c.389.633,7.92-.731,9.343-1.062.148-.034.254-.121.324-.265.336-.688-.234-2.423-.613-3.29-.641.51-2.009.78-3.088.126-.426.264-3.012,1.869-5.285,3.303-.912.575-.826.954-.681,1.188h0Z",
    style: {
      fill: "#fffffa"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M151.526,179.868c-.011,0-.023,0-.034-.002-.301-.045-1.1-.163-1.158-.846-.011-.126.083-.237.209-.248.127-.008.237.083.248.209.013.15.112.334.769.432.125.019.211.135.193.26-.017.114-.115.195-.226.195Z",
    style: {
      fill: "#fffffa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.71,178.995c-.487-.02-.952-.272-1.224-.659-.073-.103-.048-.246.056-.319.104-.072.246-.047.319.056.191.273.52.45.858.464.126.005.225.112.22.238-.005.123-.107.22-.229.22Z",
    style: {
      fill: "#fffffa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.712,178.211c-.386,0-.852-.243-1.022-.468-.076-.101-.056-.244.044-.321.101-.077.244-.056.321.044.107.141.552.342.74.275.119-.044.25.019.293.138.043.119-.019.25-.138.293-.073.026-.153.038-.238.038Z",
    style: {
      fill: "#fffffa"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M148.833,173.699c-.008.267-.23.48-.503.482-6.609.032-6.807.21-6.833-.445-2.028-50.701-1.966-47.431-1.791-48.713.508-3.718,1.589-8.924,2.694-11.23,4.627.029,9.934-.066,14.612-.236,1.295,2.328,2.738,7.627,3.372,11.254.282,1.618-1.079,49.044-1.073,48.818-.007.267-.228.48-.5.483-6.565.065-6.771.244-6.799-.413l-1.82-43.445c-.163-1.305-1.366,43.676-1.359,43.446Z",
    style: {
      fill: "#383f4e"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.24,127.697c-.045,0-.087-.026-.105-.07-.788-1.859-1.154-3.905-1.058-5.916.003-.063.058-.113.12-.109.063.003.112.057.109.12-.094,1.977.265,3.988,1.04,5.815.025.058-.002.125-.061.15-.015.006-.03.009-.045.009Z",
    style: {
      fill: "#fffffa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.084,123.229c-.033,0-.067-.015-.089-.042-.04-.049-.032-.121.017-.161l.172-.138c1.508-1.213,2.132-1.716,3.085-7.832.01-.062.069-.105.131-.096.062.01.105.068.096.131-.966,6.204-1.611,6.722-3.168,7.975l-.171.138c-.021.017-.047.026-.072.026Z",
    style: {
      fill: "#fffffa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.595,123.198c-.017,0-.035-.004-.051-.012-1.979-.997-2.284-1.15-4.348-8.261-.018-.061.017-.124.078-.142.062-.018.124.017.142.078,2.036,7.016,2.329,7.163,4.231,8.121.056.028.079.097.051.154-.02.04-.06.063-.102.063Z",
    style: {
      fill: "#fffffa"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148.371,129.395c.564-.045,2.421-.293,2.495-1.594.097-1.7-2.584-1.05-2.954.552-.093.401.076,1.072.459,1.041Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.808,120.084l2.762,1.931c-2.981,3.213-7.323,8.126-8.427,7.952-4.057-.64-.548-1.468.007-1.894.966-.742-.684-1.438-1.24-.925-.355.327-.211,1.046-.721,1.22-.184.063-.393-.02-.431-.207-.058-.285.541-.622.227-.829-.225-.148-.069-.966.738-1.347,5.079-2.397,2.079,2.359,7.085-5.902Z",
    style: {
      fill: "#e79a89"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.603,126.079c-.172-.353.534-.546.576-.035.014.168-.088.331-.23.425.332.187.659-.428,1-.281.645.279-.973,3.344-2.808,2.35-.392-.212-.032-.461.148-.712,1.209-1.684.367-3.127,1.315-1.747Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.168,122.441l2.139-2.358,3.204,5.113c2.696.552,3.834.065,4.76,1.52.061.097.014.228-.099.254-.567.13-.955-.234-1.146-.328-.784-.388-2.353.521-1.003,1.489,1.902,1.365,2.857-1.145,3.57-1.172.644-.025.096.997-1.378,2.221-.834.692-.805.192-2.187.24-.832.029.037.36-7.858-6.978Z",
    style: {
      fill: "#e79a89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.257,129.644c-.185,0-.339-.052-.483-.101-.139-.047-.259-.088-.386-.068-.667.107-1.069.071-1.195-.103-.062-.086-.041-.182-.019-.225.015-.028.049-.039.077-.025.028.014.039.049.025.077-.002.003-.027.058.01.108.046.061.243.19,1.084.056.156-.025.295.022.441.072.464.157,1.101.374,2.908-1.992.115-.151.131-.303.04-.387-.083-.076-.248-.08-.403.059-1.998,1.798-3.049,1.448-3.408,1.213-.395-.258-.569-.748-.423-1.193.145-.441.554-.686,1.09-.655.189.011.356.097.517.181.09.047.182.095.276.128.616.217.793.136.842.092.033-.031.041-.08.023-.146-.083-.303-.694-.849-1.461-1.015-.031-.007-.051-.037-.044-.068.007-.031.037-.051.068-.044.758.164,1.442.714,1.548,1.097.038.137-.009.217-.055.26-.139.13-.462.107-.958-.068-.101-.036-.198-.086-.291-.134-.157-.082-.306-.159-.47-.168-.483-.028-.847.188-.975.577-.13.395.025.832.377,1.061.702.458,1.924.008,3.269-1.202.206-.185.436-.17.557-.058.104.096.16.296-.027.541-1.348,1.765-2.062,2.131-2.553,2.131Z",
    style: {
      fill: "#d3785e"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146.281,92.487c1.347,1.33,4.936,1.33,6.689.138.139-.095-.433-.263,5.507,2.038.847,4.749,1.351,16.496-1.464,18.894-3.454,2.943-12.295,2.513-14.612.236-3.478-3.418-1.636-13.426-1.202-19.399.173-.245,4.883-2.104,5.082-1.908Z",
    style: {
      fill: "#fffffa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.374,115.742c-2.973,0-5.831-.665-7.053-1.866-2.903-2.853-2.158-10.147-1.56-16.008.127-1.248.248-2.427.324-3.48l.002-.032.018-.026c.203-.288,4.368-1.906,5.064-1.968.066-.006.141-.005.192.045,1.282,1.265,4.768,1.332,6.544.125q.098-.125,2.085.653c.796.311,1.925.752,3.527,1.373l.06.023.011.063c.755,4.237,1.438,16.497-1.502,19.002-1.69,1.44-4.759,2.097-7.713,2.097ZM141.31,94.448c-.077,1.045-.196,2.21-.321,3.442-.593,5.812-1.331,13.046,1.493,15.822,2.383,2.342,11.134,2.59,14.457-.242,2.671-2.276,2.351-13.518,1.437-18.724-1.571-.609-2.681-1.043-3.468-1.35-1.239-.484-1.719-.672-1.845-.699-.008.007-.017.015-.028.023-1.841,1.251-5.458,1.176-6.816-.134-.481-.044-4.512,1.57-4.908,1.862Z",
    style: {
      fill: "#eee6dc"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.399,100.271c-4.067,16.64-3.385,13.303,9.348,25.964.333.331,2.474-1.053,2.209-1.521l-7.206-12.692c1.472-5.688-1.041-11.673,3.01-16.293.507-.578,3.43-3.34,3.43-3.34-7.642,2.224-9.352,1.993-10.791,7.881Z",
    style: {
      fill: "#cb5b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.906,126.397c-.1,0-.183-.025-.24-.082-2.071-2.06-3.855-3.725-5.289-5.064q-7.511-7.013-4.191-20.591l.102-.417c1.29-5.28,2.812-5.705,8.474-7.285.727-.203,1.522-.425,2.396-.679l.455-.133-.345.326c-.029.028-2.925,2.765-3.422,3.332-2.492,2.841-2.472,6.188-2.451,9.731.012,2.124.025,4.321-.523,6.471l7.183,12.651c.181.319-.334.78-.657,1.027-.414.316-1.091.714-1.492.714ZM135.399,100.271l.111.027-.102.417q-3.287,13.448,4.125,20.369c1.435,1.339,3.22,3.007,5.294,5.069.099.098.78-.154,1.432-.652.514-.393.639-.657.597-.732l-7.229-12.732.012-.045c.552-2.135.539-4.332.527-6.457-.021-3.588-.041-6.976,2.508-9.883.406-.462,2.305-2.274,3.095-3.023-.699.201-1.346.381-1.945.549-5.56,1.552-7.055,1.969-8.313,7.119l-.111-.027Z",
    style: {
      fill: "#a23333"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M163.812,100.432c4.066,16.637,3.013,12.043-9.039,26.18-.288.338-2.311-1.552-2.098-1.944l6.786-12.485c-1.472-5.688,1.041-11.673-3.01-16.293-.353-.403-3.387-3.329-3.387-3.329,7.598,2.216,9.309,1.986,10.748,7.871Z",
    style: {
      fill: "#cb5b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.674,126.767c-.142,0-.339-.087-.594-.263-.535-.368-1.726-1.485-1.505-1.891l6.765-12.445c-.548-2.15-.536-4.347-.523-6.472.021-3.543.04-6.889-2.451-9.731-.346-.395-3.35-3.293-3.38-3.322l-.334-.322.446.13c.87.254,1.662.475,2.386.678,5.637,1.576,7.152,2,8.441,7.276l.055.224q3.155,12.909-2.833,19.163c-1.65,1.724-3.705,3.869-6.284,6.895-.046.054-.108.08-.186.08ZM153.476,92.799c.801.774,2.775,2.689,3.061,3.015,2.549,2.907,2.529,6.295,2.508,9.883-.012,2.125-.025,4.322.527,6.457l.011.044-.021.04-6.786,12.485c-.031.065.134.409.67.945.65.649,1.154.91,1.243.868,2.581-3.029,4.638-5.176,6.29-6.902q5.902-6.163,2.776-18.95l-.055-.224c-1.258-5.147-2.745-5.563-8.28-7.11-.6-.168-1.246-.348-1.945-.55Z",
    style: {
      fill: "#a23333"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M153.229,92.609c-1.616,1.487-5.91,1.706-7.3-.144,1.412-5.517-.363-.97,6.381-2.786.21-.057.165.103.919,2.93Z",
    style: {
      fill: "#cb5b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.443,93.903c-.222,0-.445-.01-.665-.03-1.339-.122-2.383-.598-2.94-1.339l-.033-.044.014-.053c.135-.529.242-.966.329-1.324.265-1.089.354-1.455.578-1.57.156-.08.323-.013.575.09.614.249,1.891.768,4.981-.064.032-.009.106-.028.179.014.126.074.171.248.417,1.215.108.425.256,1.002.463,1.782l.018.067-.051.047c-.81.745-2.333,1.21-3.864,1.21ZM146.054,92.439c.526.664,1.498,1.091,2.744,1.205,1.647.151,3.402-.29,4.302-1.074-.199-.747-.341-1.303-.446-1.716-.169-.662-.262-1.026-.315-1.076-3.165.865-4.49.326-5.127.067-.187-.076-.322-.13-.384-.099-.131.067-.241.519-.46,1.42-.084.347-.186.767-.315,1.273Z",
    style: {
      fill: "#a23333"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.462,85.888c-.604-1.758,1.067-6.737-1.122-9.585-1.989-2.588-6.871-1.632-5.572.481,5.946,9.676,2.092,4.889,6.694,9.104Z",
    style: {
      fill: "#493c35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.279,85.728c.636-1.851.313-7.363,1.898-9.425,1.871-2.435,5.496-1.441,5.682-.753.068.432.529,1.435.163,1.685-4.367,2.985-4.221,3.839-4.801,6.583-.247,1.17-2.864,1.87-2.943,1.91Z",
    style: {
      fill: "#493c35"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.784,75.484c.014-.122.202-.1.188.022-.06.5-.094,1.017.197,1.37.187.227-.601.418-.385-1.392Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.011,75.697c1.108-1.221,3.742-.323,3.459-.006-.034.039-.094.043-.133.009-.502-.429-2.361-.788-3.185.12-.083.092-.224-.032-.141-.123Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.57,76.106c.128.005.111.195-.008.185-.374-.016-.753.051-1.097.194-.253.105-.23-.439,1.106-.379Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.357,78.961c.648-1.19,2.575-1.085,3.124-2.227.054-.111.224-.031.171.079-.59,1.227-2.521,1.121-3.128,2.236-.059.108-.225.021-.166-.087Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.524,79.032c-.538-.675-.263-2.142-1.219-2.223-.473-.04.667-.778,1.038,1.216.061.318.131.645.329.893.077.097-.072.21-.149.114Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.419,76.145c-.131.02-.354-.375.694-.093.238.064.463.125.682.077.121-.027.164.153.042.18-.497.11-.971-.232-1.417-.164Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.524,75.447c.717-.436,1.6-.581,2.423-.398.122.027.079.208-.042.18-.775-.173-1.606-.036-2.281.374-.106.065-.206-.092-.1-.157Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.444,77.469c.075-.098.226.013.151.111-.672.877-1.025,1.963-.995,3.059.017.64-.749-1.092.844-3.17Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.458,83.754c.618-.139,1.713-1.206,1.578-2.46-.013-.123.175-.139.188-.019.143,1.325-1.002,2.497-1.724,2.66-.121.028-.164-.153-.042-.18Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.814,80.632c0-.122.189-.122.189,0,0,.26.078,1.616,1.613,2.739.042.031.05.089.019.129-.172.227-1.821-1.298-1.821-2.869Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.974,81.99c-.514-.868.105-1.909.162-2.752.068-1.014-.654-2.045-1.644-2.348-.05-.015-.077-.067-.062-.116.095-.3,2.015.685,1.894,2.475-.058.855-.652,1.863-.187,2.647.063.106-.101.198-.163.093Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.392,92.854c.733-4.163-3.641-3.973,1.273-7.1.104-.067.208.088.103.155-4.778,3.041-.433,2.678-1.19,6.976-.021.121-.207.089-.186-.031Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.296,91.993c.359-.511-.302-1.722.168-2.183.088-.087.222.044.134.131-.372.365.263,1.576-.146,2.157-.071.101-.226-.004-.155-.105Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.815,91.958c.921-1.472-.441-2.088.425-3.596.062-.107.226-.016.164.091-.82,1.428.542,2.051-.428,3.602-.065.104-.226.008-.161-.097Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.091,89.415c.012-.123.199-.104.188.017-.07.729-.197,1.858.463,2.59.281.313-.93.346-.651-2.608Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.037,92.384c-.899-1.229.157-1.599-.404-3.702-.032-.119.151-.164.183-.047.573,2.147-.466,2.492.375,3.641.073.1-.081.207-.153.108Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.55,89.994c1.512-2.501-.907-4.333-1.6-4.333-.125,0-.125-.185,0-.185.845,0,3.35,1.988,1.763,4.612-.51.843-.816,2.233-.422,3.009.023.046.004.101-.043.124-.308.149-.641-1.668.302-3.227Z",
    style: {
      fill: "#372c28"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M194.564,84.136c-.032,2.621-.9,4.564,3.92,6.832-2.869,3.947-5.695,5.406-5.695,5.406,0,0-6.045-2.721-8.122-4.522,2.555-1.859,4.413-2.083,4.365-4.576-.011-.598.017-3.045.033-3.092l5.499-.049Z",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.454,75.187c-2.334-3.264-7.841-2.439-8.482,2.569-.636,4.968,1.768,8.88,3.165,9.262,1.265.347,2.515.5,3.573-.216,2.778-1.88,3.851-8.67,1.745-11.615Z",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.277,71.994c-.406,1.54-2.538,1.125-2.128,3.095l.79,6.16c.108-1.25.296-4.011.875-4.287,1.985-.946,5.8-.762,7.461.036.49.236,1.116,4.524,1.116,4.524,2.937-7.136.143-7.5.286-8.901.172-1.675-2.111.32-3.073-1.047-.268-.381-1.448.463-1.719-.016-.511-.902-2.071.106-2.158.487-.289-.383-1.303-.611-1.45-.051Z",
    style: {
      fill: "#343540"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.467,78.249c-1.073-.236-2.914.918-2.316,1.039.195.04.743-.29.953-.349.421-.117,1.236-.059,1.466-.335.094-.114.034-.325-.102-.355Z",
    style: {
      fill: "#343540"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.847,78.624c.231.276,1.045.217,1.466.333.21.058.758.387.954.347.598-.122-1.248-1.283-2.318-1.034-.152.035-.196.242-.102.355Z",
    style: {
      fill: "#343540"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M186.404,79.976c.949-.279,1.009,1.708,1.011,2.694.005,1.944-2.506-2.255-1.011-2.694Z",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.607,80.948c.028-.091.164-.048.136.042-.167.547-.001.867.223.99.035.019.047.062.028.097-.126.23-.627-.348-.388-1.129Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.998,79.949c-.949-.279-1.009,1.708-1.011,2.694-.005,1.944,2.506-2.255,1.011-2.694Z",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.796,80.921c-.028-.091-.164-.048-.136.042.167.547.001.867-.223.99-.035.019-.047.062-.028.097.126.23.627-.348.388-1.129Z",
    style: {
      fill: "#d3785e"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M189.506,80.816c-.311,0-.554-1.182.2-1.182.402,0,.309,1.182-.2,1.182Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.123,80.863c.311,0,.554-1.182-.2-1.182-.402,0-.309,1.182.2,1.182Z",
    style: {
      fill: "#372c28"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.097,86.25c.039-.03.095-.023.125.016.816,1.057,3.693,1.417,5.075-.093.08-.087.211.034.131.12-2.039,2.228-5.843.351-5.331-.043Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.295,82.741c-.031-.131.191-.143.331-.174.513-.115.536.137.298-2.016-.047-.42-.118-.646.032-.658.142-.009.104.158.157.637.259,2.339.264,2.052-.703,2.282-.05.012-.102-.019-.115-.07Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.659,84.59c-.127-.231.205-.169,2.237-.383.61-.064-1.181,2.303-2.237.383Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M199.789,176.851c.87.67,1.821.84,3.048.133l-.174-6.027-3.889.109,1.015,5.785Z",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.023 176.795 182.102 177.09 182.652 171.368 178.886 171.474 179.023 176.795",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M203.353,180.662c-.405.295-.347.214-9.154.633-1.763.084-1.841-.826-.929-1.393,1.389-.864,6.411-3.644,6.729-3.456.902.531,1.359.618,2.775.421.231-.032,1.792,2.912.578,3.796Z",
    style: {
      fill: "#393838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.771,179.025c.071.259.125.528.113.807-.012.273-.093.574-.305.79-.209.219-.5.322-.771.382-.287.057-.541.071-.812.105-1.067.111-2.137.179-3.207.254-1.072.042-2.144.095-3.219.086-.538-.009-1.075-.018-1.614-.061-.269-.027-.538-.054-.809-.126l-.102-.035c-.034-.014-.072-.041-.103-.062-.048-.046-.098-.097-.14-.154-.084-.112-.135-.258-.111-.396l.023.002c-.013.131.043.26.129.359.042.051.091.095.142.139.028.016.054.033.084.044l.095.027c.26.055.529.067.796.079.535.021,1.07.013,1.606.003,1.071-.024,2.141-.076,3.21-.137,1.069-.058,2.138-.125,3.207-.203.266-.024.536-.031.798-.075.259-.048.523-.135.714-.321.197-.18.288-.448.314-.709.025-.265-.009-.532-.059-.794l.023-.005Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.139,178.542c-.014,0-.029-.003-.043-.008-.489-.196-.916-.522-1.233-.943-.038-.051-.028-.124.023-.162.051-.038.124-.028.162.023.292.387.684.687,1.134.868.059.024.088.091.064.15-.018.045-.062.073-.107.073Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.113,179.104c-.016,0-.032-.003-.047-.01-.011-.005-1.127-.52-1.094-1.058.004-.063.062-.112.123-.108.064.004.112.059.108.123-.015.243.547.648.957.832.058.026.084.094.058.153-.019.043-.061.068-.106.068Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.245,179.552c-.421-.178-.973-.411-1.186-.937-.024-.059.005-.127.064-.151.059-.024.127.005.151.064.177.436.678.648,1.044.803l-.027.114-.045.107Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.185,180.738c-.723,0-1.493-.078-1.644-.769-.014-.062.026-.124.088-.138.062-.014.124.026.138.088.133.609.983.595,1.734.583.103-.002.2,0,.299-.003.064,0,.116.052.116.116s-.052.116-.116.116c-.091-.003-.193.002-.295.003-.104.002-.211.003-.32.003Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.642,180.639c-.405.295-.347.214-9.153.633-1.763.084-1.841-.826-.929-1.393,1.389-.864,6.411-3.644,6.729-3.456.902.531,1.359.618,2.775.421.231-.032,1.792,2.912.578,3.796Z",
    style: {
      fill: "#393838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.06,179.001c.071.259.125.528.113.807-.012.273-.093.574-.305.79-.209.219-.5.322-.771.382-.287.057-.541.071-.812.105-1.067.111-2.137.179-3.207.254-1.072.042-2.144.095-3.219.086-.538-.009-1.075-.018-1.614-.061-.269-.027-.538-.054-.808-.126l-.102-.035c-.034-.014-.072-.041-.103-.062-.048-.046-.098-.097-.14-.154-.084-.112-.135-.258-.111-.396l.023.002c-.013.131.043.26.129.359.042.051.091.095.142.139.028.016.054.033.084.044l.095.027c.26.055.529.067.796.079.535.021,1.07.013,1.606.003,1.071-.024,2.141-.076,3.21-.137,1.069-.058,2.138-.125,3.207-.203.266-.024.536-.031.798-.075.259-.048.523-.135.714-.321.197-.18.288-.448.314-.709.025-.265-.009-.532-.059-.794l.023-.005Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.428,178.518c-.014,0-.029-.003-.043-.008-.489-.196-.916-.522-1.233-.943-.038-.051-.028-.124.023-.162.051-.039.124-.028.162.023.291.387.684.687,1.134.868.059.024.088.091.064.15-.018.045-.062.073-.107.073Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.402,179.081c-.016,0-.032-.003-.047-.01-.011-.005-1.127-.52-1.094-1.058.004-.063.059-.112.123-.108.064.004.112.059.108.123-.015.243.547.649.957.832.058.026.084.094.058.153-.019.043-.061.068-.106.068Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.534,179.528c-.421-.178-.973-.411-1.186-.937-.024-.059.005-.127.064-.151.059-.023.127.005.151.064.177.436.678.648,1.044.803l-.028.114-.045.107Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.474,180.714c-.723,0-1.493-.078-1.644-.769-.014-.062.026-.124.088-.138.062-.014.124.026.138.088.133.609.983.596,1.734.583.103-.002.199-.006.299-.003.064,0,.116.052.116.116s-.052.116-.116.116c-.089.001-.193.002-.295.003-.104.002-.211.003-.32.003Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.833,175.582c.136.022.269-.065.303-.199,5.159-20.214-.145-10.724,7.515-41.735,8.186,43.825,7.588,41.184,7.911,41.189l4.788.072c.502.008-.959-55.919-2.872-60.768l-18.381.059c-3.088,9.398-3.982,56.657-4.048,60.347-.005.284-.135.229,4.784,1.033Z",
    style: {
      fill: "#434b60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.876,175.701c-.02,0-.04-.002-.061-.005l-1.419-.231q-3.473-.565-3.463-.898c.093-5.218.987-51.069,4.054-60.402l.026-.079,18.543-.059.029.073c1.141,2.892,2.016,23.32,2.34,31.968.487,13.016.824,28.476.529,28.902l-.035.051-.071.006-4.788-.073c-.014.014-.075.047-.145.015q-.206-.098-3.227-16.343c-1.083-5.824-2.552-13.721-4.552-24.43-4.073,16.56-4.373,21.31-4.638,25.506-.222,3.521-.414,6.562-2.75,15.711-.044.171-.201.289-.373.289ZM182.181,114.317c-3.088,9.649-3.98,58.168-4.016,60.234-.001.04-.002.062,0,.069.072.097.942.239,3.268.617l1.419.231c.078.014.152-.037.172-.113,2.33-9.128,2.521-12.159,2.743-15.669.268-4.249.573-9.064,4.772-26.065l.128-.518.098.525c2.05,10.976,3.549,19.037,4.65,24.956,2.398,12.894,2.927,15.737,3.096,16.146.016-.005.035-.007.053-.007l4.707.071c.188-1.097-.036-14.308-.585-28.919-.673-17.925-1.506-29.416-2.288-31.616l-18.217.058Z",
    style: {
      fill: "#383f4e"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.631,132.645c-.058,0-.108-.043-.115-.102-.514-4.352-.337-7.114-.207-9.132.111-1.735.179-2.782-.299-3.645-.031-.056-.011-.126.045-.157.056-.031.126-.011.157.045.511.922.442,1.995.328,3.772-.129,2.008-.306,4.759.206,9.09.007.063-.038.121-.101.128-.005,0-.009,0-.014,0Z",
    style: {
      fill: "#383f4e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.492,126.128c-.157,0-.306-.029-.443-.148-.411-.357-.667-1.423-.929-6.261-.003-.064.046-.118.109-.122.063-.006.118.045.122.109.225,4.153.447,5.749.849,6.099.122.106.263.1.5.079.173-.015.369-.032.596.013.063.012.103.073.091.136-.012.063-.074.104-.136.091-.195-.038-.366-.024-.532-.009-.078.007-.155.013-.229.013Z",
    style: {
      fill: "#383f4e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.417,174.581c-.005,0-.011,0-.016-.001-.063-.009-.108-.067-.099-.13.749-5.452,1.377-10.073,1.912-14.013,2.698-19.848,3.044-22.399,4.63-26.868.021-.06.087-.092.148-.07.06.021.092.088.07.148-1.578,4.447-1.924,6.994-4.619,26.822-.536,3.941-1.164,8.562-1.912,14.014-.008.058-.057.1-.114.1Z",
    style: {
      fill: "#383f4e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.285,124.868c-.038,0-.075-.019-.098-.053-1.254-1.962-2.878-4.354-4.239-6.243-.037-.052-.026-.124.026-.161.052-.037.124-.026.161.026,1.363,1.892,2.99,4.288,4.246,6.253.034.054.019.125-.035.16-.019.012-.041.018-.062.018Z",
    style: {
      fill: "#383f4e"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M188.132,89.581c1.103,3.064,6.424,2.639,8.153.121,2.07.717,5.089,2.406,6.016,3.148,1.57,3.916,1.433,27.481-.906,27.383-6.267-.262-22.264,4.124-20.826-4.216,1.349-7.821-1.28-21.243,1.095-24.363.609-.8,6.469-2.073,6.469-2.073Z",
    style: {
      fill: "#365f5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.924,121.273c-2.894,0-5.377-.414-6.659-1.786-.792-.847-1.065-2.021-.811-3.49.605-3.509.41-8.077.221-12.495-.233-5.457-.435-10.17.896-11.918.617-.81,5.932-1.985,6.536-2.116l.099-.021.034.095c.405,1.125,1.429,1.847,2.884,2.034,1.987.255,4.118-.56,5.065-1.939l.05-.073.083.029c2.105.729,5.122,2.424,6.051,3.167l.024.019.011.028c1.473,3.673,1.469,24.454-.477,27.204-.164.232-.346.348-.542.337-1.559-.064-3.757.162-6.085.403-2.452.254-5.049.522-7.38.522ZM188.06,89.715c-1.687.371-5.835,1.393-6.304,2.009-1.28,1.682-1.071,6.581-.849,11.768.189,4.43.385,9.01-.224,12.544-.244,1.413.002,2.49.752,3.293,2.236,2.393,8.404,1.755,13.846,1.191,2.336-.242,4.542-.47,6.119-.404.111.005.227-.076.343-.24,1.921-2.715,1.914-23.231.462-26.956-.931-.733-3.815-2.351-5.876-3.081-1.017,1.403-3.198,2.226-5.234,1.966-1.482-.191-2.582-.95-3.036-2.09Z",
    style: {
      fill: "#264445"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M195.552,106.811c-1.485.058-9.519.092-9.587-1.39-.067-1.478-.199-7.299,1.27-7.031,12.868,2.34,8.88-2.913,9.079,7.846.006.35-.369.56-.762.576Z",
    style: {
      fill: "#babcbe"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M186.56,102.596c-.014,0-.028-.003-.042-.008-.059-.023-.089-.091-.065-.15.179-.453.577-.596,1.08-.777.396-.142.889-.319,1.433-.702.178-.125.355-.267.526-.404.448-.359.91-.731,1.481-.878.062-.015.125.021.141.083.016.062-.021.125-.083.141-.522.135-.945.474-1.394.834-.174.14-.353.284-.538.413-.569.4-1.079.583-1.488.73-.484.174-.803.289-.943.644-.018.045-.062.073-.108.073Z",
    style: {
      fill: "#264445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.261,103.763c-.035,0-.07-.016-.093-.047-.038-.051-.027-.124.024-.162.748-.555,1.521-1.128,2.374-1.553.921-.46,1.419-.834,1.818-1.135.529-.399.878-.662,1.762-.734.064-.005.12.042.125.106.005.064-.042.12-.106.125-.817.066-1.109.287-1.641.688-.407.307-.914.689-1.854,1.158-.834.416-1.599.983-2.339,1.532-.021.015-.045.023-.069.023Z",
    style: {
      fill: "#264445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.852,105.382c-.015,0-.031-.003-.045-.009-.059-.025-.086-.093-.061-.152.287-.674.668-.741,1.15-.826.358-.063.803-.142,1.38-.487l1.541-.921c.054-.033.126-.015.159.04.033.055.015.126-.04.159l-1.541.921c-.613.367-1.082.449-1.458.516-.477.084-.74.131-.977.689-.019.044-.061.07-.106.07Z",
    style: {
      fill: "#264445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.531,104.615c-.012,0-.023-.002-.035-.005-.061-.019-.095-.084-.075-.145.128-.405.544-.455.911-.499.208-.025.404-.048.534-.127.102-.062.186-.159.274-.26.111-.128.225-.26.389-.338.057-.028.127-.003.154.054.028.058.003.127-.054.154-.121.058-.215.166-.314.281-.096.111-.195.225-.328.306-.173.106-.404.133-.627.16-.395.047-.64.093-.718.339-.016.049-.061.081-.11.081Z",
    style: {
      fill: "#264445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.213,100.349c-.013,0-.026-.002-.039-.007-.06-.021-.092-.088-.07-.148.17-.477.331-.511.581-.527.214-.014.507-.032,1.056-.572.045-.045.119-.044.164.002.045.046.044.119-.002.164-.611.599-.968.622-1.203.637-.182.012-.25.016-.378.374-.017.047-.061.077-.109.077Z",
    style: {
      fill: "#264445"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M199.747,109.192c.098.184.472.303.584.275.233-.059.144-.461.101-.871-.093-.886-.234-1.149-1.124-1.65-.126-.071-.178.003-.158.138.047.328.592,2.099.597,2.108Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.894,105.959c.634.286.629.41.951.981.451.801.931.963,1.125,1.253.425.637-.644,1.023-1.218-.182-1.068.551-1.88-1.755-3.524-.722-.39.245.218.704.897.865.253.06,1.19.213,1.274.578.052.228-.16.468-.756.328-2.351-.551-2.887.047-3.505.14-.907.137-3.23-.723-2.579-2.026.248-.496.905-.561,1.371-.734,4.504-1.679,2.163-2.193,5.962-.481Z",
    style: {
      fill: "#e7a68a"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M178.472,111.571c5.38,1.102,13.437.538,16.345-2.183.404-.378-.505-2.582-.58-2.813-4.142-.043-9.142-.982-13.26-1.03l1.999-1.929c2.143-10.436-1.372-11.863-1.372-11.863.06-.099-10.581,18.292-3.132,19.818Z",
    style: {
      fill: "#365f5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.07,112.211c-1.972,0-3.923-.178-5.622-.526-1.102-.226-1.883-.829-2.319-1.791-2.103-4.636,4.32-16.332,5.309-18.084-.003-.001.125-.214.125-.214l.095.055c.264.116,3.527,1.776,1.43,11.988l-.007.035-1.823,1.759c1.984.042,4.187.279,6.321.509,2.254.243,4.584.494,6.658.516h.083s.026.08.026.08c.01.029.032.09.065.175.626,1.665.771,2.49.484,2.758-1.987,1.86-6.453,2.739-10.825,2.739ZM178.495,111.458c5.41,1.108,13.41.496,16.243-2.155.11-.103.187-.567-.543-2.508-.015-.041-.029-.077-.04-.106-2.065-.027-4.37-.276-6.6-.516-2.23-.24-4.535-.489-6.579-.513l-.282-.003,2.176-2.1c1.883-9.211-.699-11.325-1.222-11.649-.955,1.689-7.37,13.343-5.308,17.889.404.891,1.129,1.45,2.155,1.66h0Z",
    style: {
      fill: "#264445"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M191.287,109.138c-.284-1.021-.17-2.671-.121-2.654-1.076-.388-1.976,1.237-2.73-.59-.294-.791-3.178-3.603-2.75-2.417.159.44.634,1.219.391,1.023-1.706-1.376-3.503-3.343-3.374-2.493.056.371,2.367,2.766,2.135,2.573-.054-.045-2.794-2.468-2.864-2.471-.97-.045.76,1.429,2.21,2.933.184.191-2.668-1.955-2.671-1.954-.66.198.257.789,2.606,2.878.318.282-2.812-2.121-2.425-.965,2.834,2.634,4.641,3.438,5.311,3.667.279.207,4.282.47,4.282.47Z",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.286,105.967c.359.284.755.518,1.175.696.232.099-.013.443-1.283-.56-.09-.071.017-.207.107-.136Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.55,105.164c.428.392.915.708,1.446.94.105.045.036.205-.069.159-1.702-.743-1.608-1.311-1.377-1.099Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.152,104.714c.259.357.655.615,1.086.71.113.026.074.194-.037.17-.472-.104-.905-.387-1.189-.778-.068-.093.073-.195.14-.102Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.216,104.793c-.051-.103.106-.18.156-.077.184.37.629.725,1.08.86.111.034.06.199-.049.166-.504-.15-.987-.546-1.186-.949Z",
    style: {
      fill: "#d3785e"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M206.037,111.799c-.723,3.703-13.887,1.234-18.15-2.412-.254-.217,1.268-3.219,1.508-3.225,1.622-.044,7.674-.141,10.528,1.112-.071-.239-.84-14.619,2.378-14.424,3.445.208,4.398,15.561,3.736,18.95Z",
    style: {
      fill: "#365f5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.595,113.754c-4.461,0-10.966-1.87-13.784-4.28-.089-.077-.114-.228.06-.718.224-.632,1.196-2.702,1.52-2.711,2.223-.061,7.617-.076,10.404,1.049-.097-1.569-.518-11.364,1.409-13.794.318-.401.687-.591,1.102-.567.458.028.891.301,1.288.814,2.458,3.176,3.173,15.109,2.555,18.274-.136.695-.678,1.212-1.61,1.537-.78.272-1.794.396-2.945.396ZM187.975,109.309c3.435,2.924,12.825,5.107,16.49,3.831.85-.296,1.341-.754,1.459-1.363l.114.022-.114-.022c.596-3.051-.139-15.023-2.511-18.088-.354-.457-.73-.701-1.119-.724-.314-.019-.592.115-.849.41-2.017,2.315-1.498,13.427-1.409,13.87l.044.218-.202-.084c-2.68-1.176-8.191-1.163-10.459-1.103-.317.227-1.505,2.722-1.444,3.033Z",
    style: {
      fill: "#264445"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M189.644,73.527c.076-.364.043-.756-.093-1.103-.057-.145.163-.233.22-.086.153.389.19.829.105,1.238-.032.153-.264.105-.232-.048Z",
    style: {
      fill: "#3a3d4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.41,73.319c-.403-1.855.24-1.65.176-1.415-.124.453-.037.942.055,1.365.059.268.553-1.365.802-1.247.21.099-.129.395-.518,1.344-.101.246-.459.212-.515-.046Z",
    style: {
      fill: "#3a3d4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.293,74.2c.51-.199.887-.698.938-1.243.015-.157.25-.133.236.022-.059.632-.496,1.211-1.088,1.442-.146.057-.232-.164-.086-.221Z",
    style: {
      fill: "#3a3d4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.732,73.732c-.371-1.57.482-1.472.304-1.184-.255.413-.196.611-.074,1.13.036.152-.195.207-.231.054Z",
    style: {
      fill: "#3a3d4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.884,77.042c.43-.287.794-.931.749-1.324-.018-.155.217-.184.235-.027.056.484-.343,1.208-.853,1.548-.13.087-.262-.11-.131-.197Z",
    style: {
      fill: "#3a3d4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.387,76.474c-.375-.453-.537-1.333-.24-1.275.064.012.106.074.094.138-.076.4.322,1.133.535,1.133.267,0,.057.542-.389.004Z",
    style: {
      fill: "#3a3d4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.925,76.017c.031.154-.201.2-.232.046-.084-.421-.192-.729-.281-.947-.18.744.078,1.01-.145,1.042-.437.063.048-3.193.659-.142Z",
    style: {
      fill: "#3a3d4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.606,74.169c.649-.979,1.379-.179,1.891-1.835.046-.15.272-.08.226.07-.544,1.758-1.353,1.041-1.92,1.896-.086.13-.284,0-.197-.131Z",
    style: {
      fill: "#3a3d4a"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.107,95.477c.215-.814-.427-4.808-.76-3.596-.124.45-.19,1.36-.27,1.059-.564-2.112-.866-4.758-1.245-3.993-.165.334.298,3.628.226,3.335-.017-.068-.802-3.634-.856-3.678-.737-.602-.21,1.604.081,3.671.037.263-.993-3.144-.996-3.145-.631-.225-.244.791.423,3.858.09.415-1.013-3.363-1.361-2.199.74,3.792,1.707,5.5,2.104,6.076",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.841,93.085c.122.44.301.861.531,1.251.126.216-.261.353-.692-1.203-.031-.111.131-.158.161-.048Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.501,92.587c.115.568.319,1.108.606,1.607.057.098-.088.188-.144.089-.919-1.596-.524-2.002-.462-1.696Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.229,92.573c.002.441.167.882.452,1.21.074.087-.051.201-.125.116-.312-.359-.493-.842-.495-1.325,0-.115.167-.116.168-.001Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.02,93.257c.018-.114.185-.084.166.028-.064.408.084.956.364,1.328.068.092-.066.196-.133.106-.311-.416-.468-1.019-.396-1.463Z",
    style: {
      fill: "#d3785e"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.524,82.12c.032,2.621.9,4.564-3.92,6.832,2.869,3.947,5.695,5.406,5.695,5.406,0,0,6.045-2.721,8.122-4.522-2.555-1.859-4.413-2.083-4.365-4.576.011-.598-.017-3.045-.033-3.092l-5.499-.049Z",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.379,84.786c1.057.715,2.307.562,3.573.216,1.369-.375,3.81-4.22,3.165-9.262-.81-6.325-9.912-6.382-9.599,2.068.086,2.314.934,5.674,2.862,6.978Z",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.55,73.21c-.103-.171.232-2.412.342-2.653.808-1.766,3.81.15,4.251,1.689.294,1.026.16,4.43-.99,6.971-.091-1.054-.59-2.391-.937-3.39-.984-2.833-2.392-2.161-2.666-2.616Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.534,71.81c.24-.713.378-1.121.055-1.771-.168-.338-3.525-3.786-6.959,1.139-1.265,1.814-1.962,3.08.051,8.229.431-.567.079-1.564.454-2.243.785-1.418,2.644-1.436,4.905-2.354.729-.296,1.246-2.263,1.494-3Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.86,73.003c.006-.016.567-1.6.489-2.636-.028-.364.651.006-.313,2.699-.041.116-.217.053-.175-.063Z",
    style: {
      fill: "#493c35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.403,70.471c-.192-.067.309-.99,1.208-1.221.988-.255,2.227.634,2.062.819-.034.038-.093.042-.131.007-1.606-1.433-2.803-.28-3.02.338-.017.049-.07.074-.119.057Z",
    style: {
      fill: "#493c35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.802,73.192c-.139-.128.912-1.257,1.986-1.317.875-.048,1.212-1.06,1.692-.527.083.092-.056.216-.138.125-.19-.21-.495.072-.705.265-.828.759-1.054-.34-2.704,1.449-.035.038-.094.04-.131.005Z",
    style: {
      fill: "#493c35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.557,75.309c-.118-.002-.125-.181.003-.186.959.02,3.07-.87,3.438-1.567.058-.109.222-.022.165.087-.35.662-2.384,1.689-3.606,1.666Z",
    style: {
      fill: "#493c35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.776,72.941c.067-.103.223-.002.156.101-.428.662-.567,1.506-.375,2.271.048.03.055.095.032.135-.255.449-.62-1.261.186-2.506Z",
    style: {
      fill: "#493c35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.153,72.488c-.302-.621-1.021-1.062-1.599-1.224-.049-.014-.078-.065-.065-.115.119-.424,2.219,1.172,1.788,1.381-.046.022-.102.003-.124-.043Z",
    style: {
      fill: "#493c35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.857,72.499c-.225-.289-.542-.508-.892-.615-.292-.089.264-.497,1.039.501.076.097-.072.211-.147.114Z",
    style: {
      fill: "#493c35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.483,74.907c-.027-.39-.661-1.735-1.438-1.907-.05-.011-.082-.061-.071-.111.085-.386,1.613.808,1.694,2.005.008.123-.177.135-.186.013Z",
    style: {
      fill: "#493c35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.356,75.817l.093-.009-.093.004c-.013-.123.29-1.68.315-1.81.023-.122.205-.086.183.034-.016.086-.322,1.67-.313,1.757-.113.019-.071.014-.184.025Z",
    style: {
      fill: "#493c35"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M108.51,76.769c.268.24,1.065.065,1.499.12.216.027.806.274.993.207.574-.206-1.415-1.082-2.442-.693-.131.05-.16.267-.05.366Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.185,76.37c-1.039-.356-2.993.613-2.411.795.19.059.769-.212.984-.249.431-.073,1.235.069,1.492-.183.106-.103.082-.313-.065-.363Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.684,77.96c-.949-.279-1.009,1.708-1.011,2.694-.005,1.944,2.506-2.255,1.011-2.694Z",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.481,78.931c-.028-.091-.164-.048-.136.042.167.547.001.867-.223.99-.035.019-.047.062-.028.097.126.23.627-.348.388-1.129Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.09,77.932c.949-.279,1.009,1.708,1.011,2.694.005,1.944-2.506-2.255-1.011-2.694Z",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.293,78.904c.028-.091.164-.048.136.042-.167.547-.001.867.223.99.035.019.047.062.028.097-.126.23-.627-.348-.388-1.129Z",
    style: {
      fill: "#d3785e"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.583,78.799c.311,0,.554-1.182-.2-1.182-.402,0-.309,1.182.2,1.182Z",
    style: {
      fill: "#372c28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.965,78.846c-.311,0-.554-1.182.2-1.182.402,0,.309,1.182-.2,1.182Z",
    style: {
      fill: "#372c28"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.992,84.233c-.039-.03-.095-.023-.125.016-.816,1.057-3.693,1.417-5.075-.093-.08-.087-.211.034-.131.12,2.039,2.228,5.843.351,5.331-.043Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.793,80.724c.031-.131-.191-.143-.331-.174-.513-.115-.536.137-.298-2.016.047-.42.118-.646-.032-.658-.142-.009-.104.158-.157.637-.259,2.339-.264,2.052.703,2.282.05.012.102-.019.115-.07Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,82.353c.077-.231-.158-.135-2.27.027-.612.047,1.577,2.052,2.27-.027Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.878,175.291c-1.22.616-2.834-.876-2.834-.876l-.225-2.425,3.641-.138-.583,3.439Z",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.826,179.994c-1.128.17-1.619-.124-1.798-.459-.404-.756.156-.354,8.004-5.342,0,0,1.217,1.213,2.917.721,2.819,6.646,1.608,3.468-9.123,5.08Z",
    style: {
      fill: "#383f4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.703,178.056c-.011,0-.023-.002-.034-.005-.567-.174-.931-.314-1.196-.772-.032-.055-.013-.126.042-.158.055-.033.126-.013.158.042.216.373.49.49,1.063.666.061.019.095.083.077.145-.015.05-.061.082-.111.082Z",
    style: {
      fill: "#eee6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.262,177.333c-.639-.033-1.252-.279-1.733-.692-.048-.042-.054-.115-.012-.163.042-.049.115-.054.163-.012.442.38,1.006.606,1.588.637.064.003.113.058.11.122-.003.062-.054.11-.115.11Z",
    style: {
      fill: "#eee6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.462,176.494s-.009,0-.014,0c-.598-.073-1.275-.156-1.824-.528-.053-.036-.067-.108-.031-.161s.108-.066.161-.031c.502.341,1.15.42,1.722.49.063.008.109.066.101.129-.007.059-.057.102-.115.102Z",
    style: {
      fill: "#eee6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.177,175.342c-1.132.766-2.922-.51-2.922-.51l-.53-2.377,3.594-.599-.142,3.485Z",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.794,181.155c-1.94.55-2.25-.613-1.679-1.002,2.507-1.71,4.754-3.59,7.099-5.539,0,0,1.361,1.049,2.985.345,3.639,6.235,2.035,3.236-8.405,6.196Z",
    style: {
      fill: "#383f4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.234,178.795c-.009,0-.019-.001-.028-.003-.576-.144-.946-.263-1.236-.706-.035-.054-.02-.125.034-.16.053-.035.125-.02.16.034.236.362.516.463,1.098.608.062.016.1.078.084.14-.013.053-.06.088-.112.088Z",
    style: {
      fill: "#eee6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.748,177.989c-.632,0-1.256-.212-1.757-.598-.051-.039-.06-.112-.021-.162.039-.051.112-.06.162-.021.461.355,1.035.55,1.616.55.068,0,.12.052.12.115,0,.066-.055.117-.12.116Z",
    style: {
      fill: "#eee6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.905,177.087c-.609-.041-1.29-.088-1.858-.429-.055-.033-.072-.104-.039-.159.033-.055.104-.072.159-.04.52.313,1.171.358,1.746.397.064.004.112.06.108.123-.004.061-.055.108-.115.108Z",
    style: {
      fill: "#eee6dc"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.145,114.937c3.634-.095,4.217,58.693,4.217,58.693-1.233.401-4.029.656-5.321.55-5.668-25.909-7.77-41.524-7.77-41.524,0,0-2.426,28.247-6.052,41.256-2.008.466-5.121-.692-5.121-.692-.037-.232-3.755-50.558,1.249-58.487l18.798.203Z",
    style: {
      fill: "#798797"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.717,174.32c-.257,0-.49-.008-.685-.024l-.085-.007-.018-.084c-4.811-21.99-7.074-36.716-7.631-40.545-.471,5.132-2.763,28.79-5.966,40.283l-.018.066-.067.016c-2.019.468-5.06-.648-5.188-.696l-.063-.024-.011-.067c-.072-.452-3.746-50.625,1.266-58.567l.034-.055,18.861.204c.137-.008.273.058.4.18,3.346,3.228,3.911,56.368,3.934,58.628v.085s-.08.026-.08.026c-1.064.346-3.258.579-4.681.579ZM115.135,174.072c1.266.084,3.868-.148,5.11-.526-.027-2.475-.646-55.276-3.862-58.378-.082-.079-.159-.12-.235-.115-.004,0-18.738-.202-18.738-.202-4.863,7.953-1.381,56.171-1.205,58.287.459.162,3.131,1.056,4.92.678,3.572-12.88,6.005-40.886,6.03-41.168l.09-1.046.14,1.04c.021.156,2.162,15.872,7.75,41.43Z",
    style: {
      fill: "#434b60"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.259,130.707c-.059,0-.109-.045-.115-.104-.447-4.466-.189-8.182,0-10.896.158-2.269.272-3.909-.087-4.825-.023-.059.006-.126.066-.15.059-.024.126.006.15.066.378.964.262,2.625.102,4.925-.188,2.705-.446,6.411,0,10.857.006.063-.04.12-.104.126-.004,0-.008,0-.012,0Z",
    style: {
      fill: "#434b60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.491,173.348c-.006,0-.013,0-.02-.002-.063-.011-.105-.07-.095-.134,2.993-17.526,5.353-33.185,6.012-39.893.006-.063.061-.107.126-.104.064.006.11.063.104.127-.66,6.713-3.021,22.379-6.015,39.909-.01.056-.059.096-.114.096Z",
    style: {
      fill: "#434b60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.984,121.774c-.04,0-.079-.021-.101-.058-.032-.055-.012-.126.043-.158,2.927-1.674,3.01-2.332,3.465-5.982.053-.426.111-.892.18-1.404.008-.063.066-.108.13-.099.063.008.108.067.099.13-.068.511-.126.977-.179,1.402-.457,3.661-.552,4.423-3.58,6.154-.018.01-.038.015-.057.015Z",
    style: {
      fill: "#434b60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.497,121.87c-.017,0-.035-.004-.051-.012-3.124-1.551-3.264-2.306-3.934-5.934-.078-.421-.163-.882-.261-1.389-.012-.063.029-.123.091-.136.063-.013.123.029.136.091.098.507.183.969.262,1.391.668,3.618.789,4.27,3.81,5.769.057.028.081.098.052.155-.02.041-.061.064-.104.064Z",
    style: {
      fill: "#434b60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.306,131.883s-.01,0-.015,0c-.069-.006-.125-.054-.143-.122-.155-.585-.697-1.061-1.289-1.132-.063-.007-.109-.065-.101-.129.007-.063.065-.111.129-.101.637.076,1.205.534,1.433,1.139.613-1.164,1.528-1.39,2.144-1.218.062.017.098.081.081.142-.017.061-.081.098-.142.08-.557-.154-1.4.08-1.95,1.247-.027.058-.084.094-.146.094Z",
    style: {
      fill: "#434b60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.014,126.229c-.435,0-.849-.199-1.199-.577-.911-.984-1.878-3.717-1.306-11.148.005-.064.062-.112.124-.107.064.005.111.061.107.124-.565,7.348.366,10.023,1.246,10.973.309.334.655.503,1.029.503.064,0,.116.052.116.116s-.052.116-.116.116Z",
    style: {
      fill: "#434b60"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.536,116.606c7.189.701,16.857.603,20.666.148,0,0-.424-1.86-1.056-1.817l-18.798-.203s-.691,1.221-.811,1.872Z",
    style: {
      fill: "#754c4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.304,117.23c-3.783,0-8.046-.144-11.78-.508l-.126-.012.023-.124c.122-.663.796-1.858.824-1.908l.034-.059h.068s18.798.204,18.798.204c.691-.053,1.122,1.707,1.168,1.907l.029.125-.128.015c-1.803.215-5.115.361-8.911.361ZM96.677,116.504c7.357.705,16.718.565,20.381.15-.172-.68-.543-1.629-.905-1.601l-18.739-.202c-.128.233-.591,1.095-.737,1.653Z",
    style: {
      fill: "#754c4d"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M111.962,117.855c.087,0,.053-3.362.053-3.283,0-.093-.628-.053-.546-.053-.087,0-.053,3.362-.053,3.283,0,.093.628.053.546.053Z",
    style: {
      fill: "#798797"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.16,117.623c.087,0,.053-3.362.053-3.283,0-.093-.628-.053-.546-.053-.087,0-.053,3.362-.053,3.283,0,.093.628.053.546.053Z",
    style: {
      fill: "#798797"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.318,117.664c-.389,0-.993-.042-1.979-.11-.634-.044-1.424-.099-2.409-.16-.117-.007-.286-.033-.408-.173-.202-.231-.175-.597-.096-1.686.021-.293.046-.638.072-1.045.006-.096.017-.276.161-.402.244-.214.664-.185,2.681-.045.634.044,1.424.099,2.41.16.117.007.286.033.408.173.202.231.175.598.096,1.687-.021.293-.046.638-.072,1.045-.006.096-.017.276-.161.402-.125.109-.296.155-.703.155ZM103.87,116.916s.018.011.089.015c.986.061,1.777.116,2.412.16,1.378.096,2.212.154,2.344.068-.01.001,0-.021.004-.083.025-.409.051-.756.072-1.05.051-.706.092-1.264.017-1.349,0,0-.018-.011-.089-.015-.987-.061-1.778-.116-2.413-.16-1.378-.095-2.212-.153-2.343-.068.002-.003,0,.021-.004.083-.025.409-.051.756-.072,1.05-.051.706-.092,1.264-.017,1.348h0Z",
    style: {
      fill: "#383f4f"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M121.97,131.482c-.382-.066-.989.26-.509.576.158.104.575.138.743.052.007.422-.974.36-1.01.769-.068.773,3.81.874,3.805-1.436,0-.494-.437-.211-.779-.243-2.299-.218-3.401-.806-2.25.282Z",
    style: {
      fill: "#d3785e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.927,127.564c-1.863-5.878-6.058-24.62-6.108-24.852-.111-.51-.053-.832.793-1.005,5.282-1.078,4.166-2.771,5.911,8.286.836,5.341.728,11.899,1.668,17.521,1.228,4.077.963,3.919.737,4.298-.781,1.308-.274,1.55-1.398,1.98-1.988.76-3.285.735-2.918.126.405-.673,3.384-.234,3.049-2.809-.237-1.827-1.964-.806-1.999.161-.009.244.154.846-.33,1.331-.064.064-.174.053-.22-.024-.97-1.643.05-2.603.816-5.014Z",
    style: {
      fill: "#e7a68a"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M121.252,91.435c1.605,2.169,3.73,11.242,2.876,11.94-2.292,1.871-5.549,3-8.157,3.245-2.533-7.042-2.338-14.853-1.482-16.177,1.562-2.414,5.464-.762,6.762.992Z",
    style: {
      fill: "#fffffa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.893,106.743l-.03-.084c-2.624-7.296-2.307-14.986-1.47-16.279.513-.794,1.323-1.23,2.341-1.262,1.782-.052,3.779,1.123,4.612,2.248,1.618,2.185,3.78,11.344,2.856,12.098-2.1,1.715-5.326,2.998-8.219,3.27l-.089.008ZM116.858,89.347c-.039,0-.078,0-.117.002-.952.03-1.677.419-2.154,1.156-.792,1.224-1.06,8.907,1.463,15.99,2.828-.286,5.96-1.541,8.005-3.211.759-.619-1.218-9.515-2.896-11.781-.78-1.053-2.627-2.156-4.301-2.156Z",
    style: {
      fill: "#eee6dc"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.921,87.52c-1.515,3.676-6.36,3.624-7.81-.078-2.143.653-4.486,1.306-6.629,1.959.513,6.139-4.045,24.785,1.582,25.536,6.645.887,17.636.868,18.798-.203.401-.37,1.84-1.408,1.799-1.953-1.58-20.619-1.926-20.941-1.169-23.483,0,0-2.413-.556-6.571-1.779Z",
    style: {
      fill: "#fffffa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.919,115.694c-3.616,0-7.751-.225-10.871-.642-3.987-.532-3.046-9.395-2.216-17.214.356-3.357.693-6.528.534-8.427l-.008-.093.089-.027c1.071-.326,2.211-.658,3.314-.979,1.103-.321,2.244-.653,3.316-.98l.102-.031.039.1c.654,1.671,2.103,2.718,3.78,2.732.012,0,.024,0,.036,0,1.657,0,3.103-1.015,3.78-2.656l.04-.096.1.029c4.106,1.208,6.54,1.772,6.564,1.777l.12.028-.035.118c-.562,1.889-.503,2.614.222,11.484.236,2.884.559,6.833.951,11.957.035.455-.682,1.087-1.485,1.749-.146.12-.27.223-.351.298-.65.598-4.017.875-8.021.875ZM96.604,89.485c.142,1.93-.19,5.064-.542,8.378-.778,7.332-1.747,16.458,2.016,16.96,6.953.928,17.616.829,18.705-.174.083-.077.211-.182.361-.306.5-.412,1.43-1.18,1.401-1.553-.393-5.123-.716-9.072-.951-11.956-.713-8.727-.785-9.605-.248-11.451-.532-.127-2.813-.683-6.359-1.724-.734,1.685-2.251,2.709-3.991,2.703-1.74-.015-3.246-1.077-3.953-2.78-1.043.317-2.148.638-3.217.95-1.071.312-2.178.634-3.222.951Z",
    style: {
      fill: "#eee6dc"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.693,103.54c-4.564.798-11.354,1.748-13.833,0-.496-.35-1.099-.555-1.099-1.239,0-2.47-.286-3.715,1.099-3.911,5.288-.749,13.833,0,13.833,0,.607,0,1.099.555,1.099,1.239,0,2.56.28,3.67-1.099,3.911Z",
    style: {
      fill: "#dfd5d4"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M101.582,114.989c-.031,0-.061-.012-.084-.036-1.069-1.13-1.816-2.529-2.158-4.047-.014-.062.025-.124.087-.138.062-.014.124.025.138.087.333,1.477,1.06,2.839,2.1,3.938.044.046.042.12-.005.164-.022.021-.051.032-.08.032Z",
    style: {
      fill: "#eee6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.341,115.348c-.056,0-.105-.04-.114-.097-.01-.063.032-.123.095-.133,1.69-.278,3.191-1.624,3.65-3.274.017-.062.082-.097.142-.081.062.017.098.081.081.142-.49,1.761-2.031,3.144-3.835,3.44-.006.001-.013.002-.019.002Z",
    style: {
      fill: "#eee6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.328,115.497c-.446-.008-1.103-1.005-1.287-1.429-.025-.059.002-.127.06-.152.059-.025.127.002.152.06.224.517.828,1.286,1.073,1.29.014-.001.033,0,.055-.047l1.272-2.678c.027-.058.096-.082.154-.055.058.027.082.096.055.154l-1.272,2.678c-.055.116-.148.179-.263.179Z",
    style: {
      fill: "#eee6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.467,104.8c-.016,0-.033-.003-.048-.011-1.29-.597-2.553-1.286-3.754-2.047-.054-.034-.07-.106-.036-.16.034-.054.106-.07.16-.036,1.193.756,2.447,1.44,3.728,2.033.058.027.083.096.056.154-.02.042-.061.067-.105.067Z",
    style: {
      fill: "#eee6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.845,105.219c-.056,0-.105-.041-.114-.098-.01-.063.033-.122.096-.132,1.762-.279,3.436-1.217,4.593-2.574.041-.049.115-.055.163-.013.049.041.054.114.013.163-1.193,1.399-2.918,2.366-4.733,2.653-.006.001-.012.001-.018.001Z",
    style: {
      fill: "#eee6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.865,91.485c-.07,0-.141-.001-.212-.004-2.011-.079-3.75-1.263-4.54-3.088-.025-.059.002-.127.06-.152.059-.026.127.002.152.06.754,1.743,2.415,2.873,4.336,2.949,1.913.078,3.651-.92,4.54-2.599.03-.056.1-.078.156-.048.056.03.078.1.048.156-.898,1.695-2.624,2.726-4.542,2.726Z",
    style: {
      fill: "#eee6dc"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.869,102.13l-1.301,5.316-5.468-12.018-2.655,1.4,4.216,15.375s1.714,4.247,6.371,1.168l3.798-9.928-4.96-1.313Z",
    style: {
      fill: "#e7a68a"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M93.412,91.435c-1.605,2.169-3.73,11.242-2.876,11.94,2.292,1.871,5.549,3,8.157,3.245,2.533-7.042,2.338-14.853,1.482-16.177-1.562-2.414-5.464-.762-6.762.992Z",
    style: {
      fill: "#fffffa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.771,106.743l-.089-.008c-2.893-.272-6.119-1.556-8.219-3.27-.923-.754,1.239-9.913,2.856-12.098.833-1.125,2.828-2.304,4.612-2.248,1.018.032,1.827.468,2.341,1.262.836,1.293,1.154,8.983-1.47,16.279l-.03.084ZM93.505,91.503c-1.678,2.267-3.655,11.162-2.896,11.781,2.045,1.67,5.178,2.925,8.005,3.211,2.523-7.083,2.255-14.766,1.463-15.99-.477-.737-1.202-1.126-2.154-1.156-1.704-.048-3.621,1.077-4.418,2.155h0Z",
    style: {
      fill: "#eee6dc"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 90.991,
    y: 107.326,
    width: 0.098,
    height: 2.501,
    transform: "translate(-33.801 41.555) rotate(-21.791)",
    style: {
      fill: "#d3785e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUsersAssigned);
export default __webpack_public_path__ + "static/media/NoUsersAssigned.a0f7480ce150437912e323d1bbc14590.svg";
export { ForwardRef as ReactComponent };